document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    '[data-search-form-button]'
  );
  const popups = document.querySelectorAll<HTMLDivElement>(
    '[data-search-form-popup]'
  );

  let activeButton: HTMLButtonElement | null = null;

  // ポップアップ位置更新関数
  const updatePopupPosition = () => {
    if (!activeButton) return;
    const buttonRect = activeButton.getBoundingClientRect();
    const popup = document.querySelector<HTMLDivElement>(
      `[data-search-form-popup][data-id="${activeButton.dataset.id}"]`
    );
    if (popup) {
      popup.style.top = `${buttonRect.bottom + 10}px`;
    }
  };

  // スクロール時にポップアップ位置を更新
  window.addEventListener('scroll', updatePopupPosition);

  // リサイズ時にもポップアップ位置を更新
  window.addEventListener('resize', updatePopupPosition);

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const buttonId = button.dataset.id as string;
      const wasActive = button.dataset.active === 'true';

      buttons.forEach((btn) => {
        btn.dataset.active = 'false';
      });
      button.dataset.active = wasActive ? 'false' : 'true';

      // アクティブなボタンを更新
      activeButton = wasActive ? null : button;

      popups.forEach((popup) => {
        if (popup.dataset.id === buttonId) {
          popup.dataset.active = button.dataset.active;
        } else {
          popup.dataset.active = 'false';
        }
      });

      // クリック時も位置を更新
      updatePopupPosition();
    });
  });

  // 親子チェックボックス連動機能を初期化
  initCheckboxLinkage();
});

/**
 * 親子チェックボックスの連動を初期化
 */
function initCheckboxLinkage(): void {
  const parentCheckboxes = document.querySelectorAll<HTMLInputElement>(
    'input[type="checkbox"][data-parent-id]'
  );

  parentCheckboxes.forEach((parentCheckbox) => {
    const parentId = parentCheckbox.dataset.parentId;
    if (!parentId) return;

    const childCheckboxes = document.querySelectorAll<HTMLInputElement>(
      `input[type="checkbox"][data-id="${parentId}"]`
    );

    if (childCheckboxes.length === 0) return;

    // 親チェックボックスのイベントリスナー
    parentCheckbox.addEventListener('change', () => {
      handleParentChange(parentCheckbox, childCheckboxes);
    });

    // 子チェックボックスのイベントリスナー
    childCheckboxes.forEach((childCheckbox) => {
      childCheckbox.addEventListener('change', () => {
        handleChildChange(parentCheckbox, childCheckboxes);
      });
    });
  });

  // ページロード時にURLパラメータの状態を反映後、連動状態を同期
  syncCheckboxStateFromUrl();
}

/**
 * 親チェックボックスの変更時の処理
 * 親にチェック → 全子にチェック / 親のチェック解除 → 全子のチェック解除
 */
function handleParentChange(
  parentCheckbox: HTMLInputElement,
  childCheckboxes: NodeListOf<HTMLInputElement>
): void {
  const isChecked = parentCheckbox.checked;
  childCheckboxes.forEach((childCheckbox) => {
    childCheckbox.checked = isChecked;
  });
}

/**
 * 子チェックボックスの変更時の処理
 * 全子にチェック → 親に自動チェック / 子の1つでも解除 → 親のチェック解除
 */
function handleChildChange(
  parentCheckbox: HTMLInputElement,
  childCheckboxes: NodeListOf<HTMLInputElement>
): void {
  const allChecked = Array.from(childCheckboxes).every((cb) => cb.checked);
  parentCheckbox.checked = allChecked;
}

/**
 * URLパラメータからチェックボックスの状態を同期
 * URLクエリパラメータでアクセス時にも連動仕様を適用
 */
function syncCheckboxStateFromUrl(): void {
  const parentCheckboxes = document.querySelectorAll<HTMLInputElement>(
    'input[type="checkbox"][data-parent-id]'
  );

  parentCheckboxes.forEach((parentCheckbox) => {
    const parentId = parentCheckbox.dataset.parentId;
    if (!parentId) return;

    const childCheckboxes = document.querySelectorAll<HTMLInputElement>(
      `input[type="checkbox"][data-id="${parentId}"]`
    );

    if (childCheckboxes.length === 0) return;

    const allChildrenChecked = Array.from(childCheckboxes).every(
      (cb) => cb.checked
    );

    // 全子がチェック済みなら親もチェック
    if (allChildrenChecked && !parentCheckbox.checked) {
      parentCheckbox.checked = true;
    }
    // 子が全てチェックでないのに親がチェック済みなら親のチェックを解除
    else if (!allChildrenChecked && parentCheckbox.checked) {
      parentCheckbox.checked = false;
    }
  });
}
